import { useMemo } from 'react';

import { useSubscription } from '../subscription.query';

export function useJournalLockState(journalDate?: string | Date | null) {
  const { status } = useSubscription();
  const unavailableBefore = status.journal_limits?.unavailable_before;

  const isLocked = useMemo(() => {
    if (!journalDate || !unavailableBefore) return false;

    const limitDate = new Date(unavailableBefore);
    const entryDate = new Date(journalDate);

    limitDate.setHours(0, 0, 0, 0);
    entryDate.setHours(0, 0, 0, 0);

    return entryDate < limitDate;
  }, [journalDate, unavailableBefore]);

  return { isLocked };
}
